<finder-polyline [polyline]="polyline" [mobilePolyline]="polyline" [viewBox]="viewBox" *ngIf="polyline && viewBox"></finder-polyline>
